// ink-component
import React from 'react';
import styled from 'styled-components';
import { NewTableVirtualContext, NewTableVirtualizedElement } from '../NewTableVirtualWrapper/NewTableVirtualWrapper';

export interface NewTableHeadProps extends React.TableHTMLAttributes<HTMLTableSectionElement> {}

/* @internal */
export const StyledHead = styled.thead<NewTableHeadProps & NewTableVirtualizedElement>`
  vertical-align: baseline;

  ${({ virtual }) =>
    virtual &&
    `
      position: sticky;
      top: 0;
      z-index: 1;
    `}
`;

/**
 * @group NewTable
 * @purpose Wraps around header rows
 * @categories table
 * @HTMLType HTMLTableHead
 */
function NewTableHead({ className, style, ...otherProps }: NewTableHeadProps) {
  const virtual = React.useContext(NewTableVirtualContext);
  const type = virtual?.type;
  const context = React.useMemo(() => ({ section: 'head' as const, type: type! }), [type]);

  if (virtual) {
    return (
      <NewTableVirtualContext.Provider value={context}>
        <StyledHead virtual={!!virtual} {...otherProps} />
      </NewTableVirtualContext.Provider>
    );
  }

  return <StyledHead {...otherProps} />;
}

NewTableHead.displayName = 'NewTable.Head';

export default NewTableHead;
